import { FontName } from '.';
import { padding, width } from './general';

const headerPadding = 20;
const inventoryWidth = 143;
const inventory = {
  frame: {
    image: 'assets/ui/hud/frames/hud_label_bg.png',
    width: inventoryWidth,
    height: 39,
    x: width - headerPadding - inventoryWidth,
    scaleMethod: '9slice',
    sourceSlices: {
      horizontal: { left: padding, right: padding },
      vertical: { top: padding, bottom: padding },
    },
    pressedOffsetY: 0,
  },
  text: {
    x: 20,
    width: inventoryWidth - 55,
    height: 35,
    align: 'right',
    verticalAlign: 'center',
    size: 22,
    color: '#9A7171',
    wordWrap: false,
    fontName: 'Body',
  },
  plus: {
    image: 'assets/ui/hud/icons/hud_plus_button_up.png',
    imagePressed: 'assets/ui/hud/icons/hud_plus_button_up.png',
    imageDisabled: 'assets/ui/hud/icons/hud_plus_button_up.png',
    x: 0,
    y: 19,
    width: 39,
    height: 41,
    pressedOffsetY: 5,
    centerOnOrigin: true,
  },
} as const;
const nameTag = {
  background: {
    image: 'assets/ui/hud/frames/hud_nametag_bg.png',
    x: 5,
    y: -10,
    width: 249,
    height: 168,
  },
  text: {
    x: 100,
    width: 125,
    height: 35,
    align: 'right',
    verticalAlign: 'center',
    size: 22,
    color: '#AB9EA7',
    wordWrap: false,
    font: 'Body',
  },
  level: {
    background: {
      image: 'assets/ui/hud/meters/level_bg.png',
      width: 101,
      height: 103,
      x: 101 / 2 - 5,
      y: 168 / 2 + 14,
      centerOnOrigin: true,
    },
    fill: {
      image: 'assets/ui/hud/meters/level_fill.png',
      width: 88,
      height: 88,
      x: 58,
      y: 50,
      scaleMethod: 'contain',
      centerOnOrigin: true,
    },
    label: {
      x: 101 / 2 - 2,
      y: 101 / 2,
      width: 80,
      height: 80,
      align: 'center',
      verticalAlign: 'center',
      size: 20,
      color: '#9A7171',
      font: 'Body',
      wordWrap: false,
      centerOnOrigin: true,
    },
  },
} as const;

export default {
  padding: headerPadding,

  // ------------------------------------------------------------
  // Coins
  // ------------------------------------------------------------
  coinLayout: {
    width: inventoryWidth + 20,
    height: 40,
    x: width - headerPadding - inventoryWidth - 20,
    y: headerPadding,
    pressedOffsetY: 5,
  },

  coinFrame: {
    ...inventory.frame,
    y: 0,
    x: 20,
  },

  coinIcon: {
    image: 'assets/ui/hud/icons/hud_coin.png',
    width: 45,
    height: 46,
    x: 133,
    y: -5,
  },

  coinText: {
    ...inventory.text,
    x: 40,
    y: -2,
  },

  coinPlus: {
    ...{
      image: inventory.plus.image,
      width: inventory.plus.width,
      height: inventory.plus.height,
    },
    x: 1,
    y: -3.6,
  },

  // ------------------------------------------------------------
  // Energy
  // ------------------------------------------------------------
  energyLayout: {
    width: inventoryWidth + 20,
    height: 40,
    x: width - headerPadding - inventoryWidth - 20,
    y: headerPadding + inventory.frame.height * 2 + 20,
    pressedOffsetY: 5,
  },

  energyFrame: {
    ...inventory.frame,
    y: 0,
    x: 20,
  },

  energyIcon: {
    image: 'assets/ui/hud/icons/hud_energy.png',
    width: 39,
    height: 46,
    x: 139,
    y: -5,
  },

  energyText: {
    ...inventory.text,
    x: 40,
    y: -2,
  },

  energyPlus: {
    ...{
      image: inventory.plus.image,
      width: inventory.plus.width,
      height: inventory.plus.height,
    },
    x: 1,
    y: -3.6,
  },

  energyRegenerationTip: {
    image: 'assets/ui/shared/frames/dark_frame_tip.png',
    x: 100,
    y: 3,
    width: 20,
    height: 10,
    centerOnOrigin: true,
  },

  energyRegenerationFrame: {
    image: 'assets/ui/shared/frames/dark_frame.png',
    scaleMethod: '3slice' as const,
    x: 86,
    y: 66,
    width: 170,
    height: 50,
    sourceSlices: {
      horizontal: { left: 20, right: 20 },
    },
    centerOnOrigin: true,
  },

  energyRegenerationText: {
    ...inventory.text,
    color: '#ffffff',
    align: 'center',
    x: 15,
    y: 9,
    width: 135,
    height: 30,
    size: 30,
  },

  // ------------------------------------------------------------
  // Gems
  // ------------------------------------------------------------

  gemLayout: {
    width: inventoryWidth + 20,
    height: 40,
    x: width - headerPadding - inventoryWidth - 20,
    y: headerPadding + inventory.frame.height + 10,
    pressedOffsetY: 5,
  },

  gemFrame: {
    ...inventory.frame,
    y: 0,
    x: 20,
  },

  gemIcon: {
    image: 'assets/ui/hud/icons/hud_gem.png',
    width: 50,
    height: 42,
    x: 133,
    y: -5,
  },

  gemText: {
    ...inventory.text,
    x: 40,
    y: -2,
  },

  gemPlus: {
    ...{
      image: inventory.plus.image,
      width: inventory.plus.width,
      height: inventory.plus.height,
    },
    x: 1,
    y: -3.6,
  },

  nameTagBackground: nameTag.background,

  levelBackground: nameTag.level.background,

  levelFill: nameTag.level.fill,

  levelLabel: nameTag.level.label,

  nameTagPetName: {
    ...nameTag.text,
    y: 50,
  },

  nameTagSpecies: {
    ...nameTag.text,
    y: 85,
  },

  nameTagAge: {
    ...nameTag.text,
    y: 118,
  },

  loveMeter: {
    view: {
      width: 110,
      height: 144,
      x: width - 3 * headerPadding - inventoryWidth - 110,
      y: 10,
    },
    image: {
      image: 'assets/ui/hud/meters/heart_bg.png',
      width: 112,
      height: 102,
    },
    highlight: {
      image: 'assets/ui/hud/meters/heart_fg.png',
      width: 17,
      height: 38,
      x: 76,
      y: 16,
    },
    fill: {
      image: 'assets/ui/hud/meters/heart_fill.png',
      width: 94,
      height: 82,
    },
    mask: {
      centerSource: false,
      mask: 'assets/ui/hud/meters/heart_mask.png',
      width: 94,
      height: 82,
      x: 56,
      y: 51,
    },
  },

  stomachMeter: {
    view: {
      width: 110,
      height: 144,
      x: width - 4 * headerPadding - inventoryWidth - 2 * 110,
      y: 10,
    },
    image: {
      image: 'assets/ui/hud/meters/stomach_bg.png',
      width: 105,
      height: 102,
    },
    highlight: {
      image: 'assets/ui/hud/meters/stomach_fg.png',
      width: 56,
      height: 60,
      x: 105 / 2,
      y: 102 / 2,
      centerOnOrigin: true,
    },
    fill: {
      image: 'assets/ui/hud/meters/stomach_fill.png',
      width: 91,
      height: 83,
    },
    mask: {
      centerSource: false,
      mask: 'assets/ui/hud/meters/stomach_mask.png',
      width: 91,
      height: 83,
      x: 53,
      y: 50,
    },
  },

  meterLabel: {
    ...inventory.frame,
    x: 0,
    y: 106,
  },

  meterText: {
    x: 5,
    height: 35,
    verticalAlign: 'center',
    size: 22,
    color: inventory.text.color,
    wordWrap: false,
    font: 'Body',
    align: 'center',
  },

  shieldBackground: {
    image: 'assets/ui/hud/frames/hud_shield_bg.png',
    width: 132,
    height: 69,
    x: 720 - 132 - headerPadding,
    y: headerPadding + 7,
    shieldPositioning: {
      horizontalSpacing: 31,
      offset: {
        x: 5,
        y: 6,
      },
    },
  },

  shieldFull: {
    image: 'assets/ui/hud/icons/hud_shield.png',
    width: 60,
    height: 60,
    centerOnOrigin: true,
  },

  star: {
    image: 'assets/ui/hud/icons/hud_star.png',
    width: 74,
    height: 75,
    x: 482,
    y: headerPadding - 3,
  },

  starText: {
    centerOnOrigin: true,
    x: 75 / 2 - 5,
    y: 75 / 2 + 2,
    width: 75,
    height: 75,
    align: 'center' as const,
    verticalAlign: 'center' as const,
    size: 38,
    color: 'white',
    wordWrap: false,
    fontName: 'Title' as FontName,
  },

  switchLayout: {
    width: 187,
    height: 85,
    x: 30,
    y: 142,
    pressedOffsetY: 5,
    centerAnchor: true,
  },

  switchFrame: {
    image: 'assets/ui/visit/buttons/btn_switchinfo.png',
    width: 187,
    height: 85,
  },

  switchText: {
    x: 66,
    y: 3,
    width: 86,
    height: 88,
    verticalAlign: 'center',
    size: 28,
    color: '#feffff',
    wordWrap: false,
    font: 'Body',
    align: 'center',
  },
} as const;
